<div class="d-flex align-items-center justify-content-start text-muted mb-2 cache-indicator-container">
    <ng-container *ngIf="cachedAt">
        <span class="border-bottom" [ngClass]="{
            'cache-refreshed': justRefreshed,
            'border-secondary': ageColor === 'secondary',
            'border-warning': ageColor === 'warning',
            'border-danger': ageColor === 'danger'
        }">
            <ng-container *ngIf="justRefreshed">
                <fa-icon [icon]="['far', 'check']" [ngClass]="{
                    'text-secondary': ageColor === 'secondary',
                    'text-warning': ageColor === 'warning',
                    'text-danger': ageColor === 'danger'
                }" class="me-1"></fa-icon>
                {{ 'common.cache-indicator.data-updated' | translate:{ name: name } }}
            </ng-container>
            <ng-container *ngIf="!justRefreshed">
                {{ 'common.cache-indicator.data-as-of' | translate:{ name: name } }} {{ cachedAt | date:'shortTime' }}
            </ng-container>
        </span>
        <span class="mx-2"></span>
        <button
            *ngIf="!justRefreshed"
            class="btn btn-sm ms-2"
            [ngClass]="{
                'btn-outline-secondary': ageColor === 'secondary',
                'btn-outline-warning': ageColor === 'warning',
                'btn-outline-danger': ageColor === 'danger'
            }"
            [disabled]="loading"
            (click)="onRefresh()">
            <fa-icon [icon]="['far', 'sync']" class="me-1"></fa-icon>
            {{ 'common.cache-indicator.reload' | translate }}
        </button>
    </ng-container>
</div>
